import api from './api';

export interface UpdateProfileDto {
  name?: string;
}

export interface ChangePasswordDto {
  currentPassword: string;
  newPassword: string;
}

export interface ProfileResponse {
  id: number;
  name: string;
  email: string;
  portal_type?: string;
  avatar?: string;
  created_at?: string;
  updated_at?: string;
}

export const profileService = {
  async getProfile(): Promise<ProfileResponse> {
    const response = await api.get<ProfileResponse>('/profile');
    return response.data;
  },

  async updateProfile(data: UpdateProfileDto): Promise<ProfileResponse> {
    const response = await api.patch<ProfileResponse>('/profile', data);
    return response.data;
  },

  async changePassword(data: ChangePasswordDto): Promise<{ message: string }> {
    const response = await api.patch<{ message: string }>('/profile/password', data);
    return response.data;
  },

  async uploadAvatar(file: File): Promise<{ avatar: string }> {
    const formData = new FormData();
    formData.append('avatar', file);
    
    const response = await api.patch<{ avatar: string }>('/profile/avatar', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },
};






